import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import viLegacy from './translations/vi';
import enLegacy from './translations/en';
import viJson from './locales/vi.json';
import enJson from './locales/en.json';

// Determine initial language: saved preference -> default 'vi'
function getInitialLang() {
  try {
    const saved = localStorage.getItem('lang');
    if (saved === 'vi' || saved === 'en') return saved;
  } catch (_) {}
  // Ignore browser language; default to Vietnamese per requirement
  return 'vi';
}

const initialLang = getInitialLang();

// Merge legacy maps with new structured JSON
const viResources = { ...viLegacy, ...viJson };
const enResources = { ...enLegacy, ...enJson };

i18n
  .use(initReactI18next)
  .init({
    resources: {
      vi: { translation: viResources },
      en: { translation: enResources }
    },
    lng: initialLang,
    fallbackLng: 'vi',
    interpolation: { escapeValue: false },
    returnNull: false
  });

// Keep <html lang> in sync
try { document.documentElement.setAttribute('lang', initialLang); } catch (_) {}

export default i18n;
